import PropTypes from 'prop-types';
import React from 'react';
import { Button, Spinner } from 'reactstrap';
import { getSeverityColorClass } from './qualityAgentHelpers';

// Suggestion row component - for AI-generated suggestions
const SuggestionRow = ({
  suggestion,
  onAdd,
  isAdding: _isAdding = false
}) => /*#__PURE__*/React.createElement("div", {
  className: "border-bottom py-3"
}, /*#__PURE__*/React.createElement("div", {
  className: "d-flex justify-content-between align-items-center"
}, /*#__PURE__*/React.createElement("div", {
  className: "flex-grow-1"
}, /*#__PURE__*/React.createElement("div", {
  className: "fw-medium"
}, suggestion.description), /*#__PURE__*/React.createElement("div", {
  className: "mt-1 quality-agent__suggestion-meta"
}, /*#__PURE__*/React.createElement("span", {
  className: "text-muted text-capitalize"
}, suggestion.category || 'general'), /*#__PURE__*/React.createElement("span", {
  className: "text-muted mx-2"
}, "\u2022"), /*#__PURE__*/React.createElement("span", {
  className: `text-capitalize ${getSeverityColorClass(suggestion.severity)}`
}, suggestion.severity || 'low'))), /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  size: "sm",
  onClick: () => onAdd(suggestion),
  disabled: _isAdding
}, _isAdding ? /*#__PURE__*/React.createElement(Spinner, {
  size: "sm"
}) : /*#__PURE__*/React.createElement(React.Fragment, null, "+ Add"))));
SuggestionRow.propTypes = {
  suggestion: PropTypes.shape({
    id: PropTypes.string,
    description: PropTypes.string,
    category: PropTypes.string,
    severity: PropTypes.string,
    query: PropTypes.string
  }).isRequired,
  onAdd: PropTypes.func.isRequired,
  isAdding: PropTypes.bool
};

// Removed defaultProps - using default parameters in function signature instead

export default SuggestionRow;